import React from 'react';
import { css } from 'emotion';
import { colors } from '@cimpress/react-components';

const errorStyle = css`
  color: ${colors.danger.base};
  margin-left: 10px;
`;
export default ({ text }) => <small className={errorStyle}>{text}</small>;
